/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {IconDefault, IconBorder, IconInheritSized, IconColors} from 'Docs/uilib/components/icon/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    strong: "strong",
    code: "code",
    p: "p"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "Default and Medium-sized icons (Responsive)"
    }), "\n", _jsx(IconDefault, {}), "\n", _jsxs(_components.h3, {
      children: ["Icons with border. ", _jsx(_components.strong, {
        children: "NB:"
      }), " Use it with caution. It should not be used where it can confuse users with being a clickable button."]
    }), "\n", _jsx(IconBorder, {}), "\n", _jsxs(_components.h3, {
      children: ["Responsive to its inherited ", _jsx(_components.code, {
        children: "font-size"
      })]
    }), "\n", _jsx(IconInheritSized, {}), "\n", _jsx(_components.h3, {
      children: "Icon color variations"
    }), "\n", _jsx(_components.p, {
      children: "All of these methods will output the same color"
    }), "\n", _jsx(IconColors, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
